module.exports = __webpack_public_path__ + "static/img/17.9325c42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/17.jpg
// module id = ppwI
// module chunks = 1